export const POPS_API_VERSION = '3'
export const POPS_REQUEST_SOURCE = 'web'
